import { __assign } from "tslib";
import Client from './client';
import { getDefaultConfig, mergeUserConfig, toClientConfig } from './config';
import { ERROR_CANNOT_GET_CONTEXT_BEFORE_INIT } from './constants';
var Rangers = /** @class */ (function () {
    function Rangers(options) {
        this.version = 'MONITOR_SDK_VERSION';
        this.Backend = options.Backend;
        this.defaultConfig = getDefaultConfig();
    }
    /**
     * Init
     * @param config
     */
    Rangers.prototype.init = function (config) {
        if (this.client) {
            return;
        }
        if (!(config === null || config === void 0 ? void 0 : config.aid)) {
            throw new Error('cannot init without aid');
        }
        this.userConfig = config;
        var clientConfig = toClientConfig(this.defaultConfig, this.userConfig, {
            version: this.version,
        });
        this.client = new Client(clientConfig, this.Backend);
    };
    /**
     * Config
     * @param config
     */
    Rangers.prototype.config = function (config) {
        if (!this.userConfig || !this.client) {
            throw new Error('cannot config before init');
        }
        this.userConfig = mergeUserConfig(this.userConfig, config);
        this.updateClientConfig();
    };
    /**
     * Report a captured exception
     * @param error
     */
    Rangers.prototype.capture = function (error) {
        var _a;
        (_a = this.client) === null || _a === void 0 ? void 0 : _a.reportError(error);
    };
    /**
     * Report a custom event
     * @param event
     */
    Rangers.prototype.report = function (event) {
        var _a;
        (_a = this.client) === null || _a === void 0 ? void 0 : _a.reportEvent(event);
    };
    /**
     * Add a breadcrumb
     * @param breadcrumb
     */
    Rangers.prototype.addBreadcrumb = function (type, payload) {
        var _a;
        (_a = this.client) === null || _a === void 0 ? void 0 : _a.addBreadcrumb(type, payload);
    };
    /**
     * Force the client to send all queued events
     */
    Rangers.prototype.sendNow = function () {
        var _a;
        (_a = this.client) === null || _a === void 0 ? void 0 : _a.flush();
    };
    Object.defineProperty(Rangers.prototype, "context", {
        get: function () {
            var _this = this;
            var agent = {
                set: function (name, data) {
                    if (!_this.userConfig) {
                        throw new Error(ERROR_CANNOT_GET_CONTEXT_BEFORE_INIT);
                    }
                    if (!_this.userConfig.context) {
                        _this.userConfig.context = {};
                    }
                    _this.userConfig.context[name] = data;
                    _this.updateClientConfig();
                    return agent;
                },
                delete: function (name) {
                    if (!_this.userConfig) {
                        throw new Error(ERROR_CANNOT_GET_CONTEXT_BEFORE_INIT);
                    }
                    if (_this.userConfig.context && name in _this.userConfig.context) {
                        delete _this.userConfig.context[name];
                    }
                    _this.updateClientConfig();
                    return agent;
                },
                clear: function () {
                    if (!_this.userConfig) {
                        throw new Error(ERROR_CANNOT_GET_CONTEXT_BEFORE_INIT);
                    }
                    _this.userConfig.context = {};
                    _this.updateClientConfig();
                    return agent;
                },
                get: function (name) {
                    var _a;
                    if (!_this.userConfig) {
                        throw new Error(ERROR_CANNOT_GET_CONTEXT_BEFORE_INIT);
                    }
                    return (_a = _this.userConfig.context) === null || _a === void 0 ? void 0 : _a[name];
                },
                toObject: function () {
                    if (!_this.userConfig) {
                        throw new Error(ERROR_CANNOT_GET_CONTEXT_BEFORE_INIT);
                    }
                    return __assign({}, _this.userConfig.context);
                },
            };
            return agent;
        },
        enumerable: false,
        configurable: true
    });
    Rangers.prototype.updateClientConfig = function () {
        if (!this.userConfig || !this.client)
            return;
        var clientConfig = toClientConfig(this.defaultConfig, this.userConfig, { version: this.version });
        this.client.updateConfig(clientConfig);
    };
    return Rangers;
}());
export default Rangers;
//# sourceMappingURL=rangers.js.map